import { responsiveToCss as r } from "./utils.js";
function i(t, n) {
  return r("background", t, n);
}
function u(t, n) {
  return r("box-sizing", t, n);
}
function f(t, n) {
  return r("display", t, n);
}
function c(t, n) {
  return r("justify-content", t, n);
}
function l(t, n) {
  return r("justify-self", t, n);
}
function s(t, n) {
  return r("justify-items", t, n);
}
function a(t, n) {
  return r("align-self", t, n);
}
function d(t, n) {
  return r("align-items", t, n);
}
function g(t, n) {
  return r("flex-direction", t, n);
}
function h(t, n) {
  return r("flex", t, n);
}
function p(t, n) {
  return r("flex-wrap", t, n);
}
function m(t, n) {
  return r("width", t, n);
}
function x(t, n) {
  return r("max-width", t, n);
}
function b(t, n) {
  return r("min-width", t, n);
}
function w(t, n) {
  return r("height", t, n);
}
function y(t, n) {
  return r("max-height", t, n);
}
function v(t, n) {
  return r("min-height", t, n);
}
function S(t, n) {
  return r("aspect-ratio", t, n);
}
function E(t, n) {
  return r("cursor", t, n);
}
function k(t, n) {
  return r("pointer-events", t, n);
}
function z(t, n) {
  return r("position", t, n);
}
function A(t, n) {
  return r("top", t, n);
}
function D(t, n) {
  return r("bottom", t, n);
}
function _(t, n) {
  return r("right", t, n);
}
function j(t, n) {
  return r("left", t, n);
}
function C(t, n) {
  return r("background-color", t, n);
}
function L(t, n) {
  return r("color", t, n);
}
function W(t, n) {
  return r("border", t, n);
}
function I(t, n) {
  return r("border-color", t, n);
}
function N(t, n) {
  return r("border-style", t, n);
}
function T(t, n) {
  return r("border-right-style", t, n);
}
function H(t, n) {
  return r("border-bottom-style", t, n);
}
function O(t, n) {
  return r("box-shadow", t, n);
}
function V(t, n) {
  return r("fill", t, n);
}
function X(t, n) {
  return r("stroke", t, n);
}
function Z(t, n) {
  return r("outline", t, n);
}
function R(t, n) {
  return r("grid-template-areas", t, n);
}
function U(t, n) {
  return r("grid-template-columns", t, n);
}
function $(t, n) {
  return r("grid-area", t, n);
}
function B(t, n) {
  return r("text-align", t, n);
}
function Y(t, n) {
  return r("text-decoration", t, n);
}
function q(t, n) {
  return r("font-weight", t, n);
}
function F(t, n) {
  return r("font-size", t, n);
}
function G(t, n) {
  return r("line-height", t, n);
}
function J(t, n) {
  return r("overflow-y", t, n);
}
function K(t, n) {
  return r("overflow-x", t, n);
}
function M(t, n) {
  return r("overflow", t, n);
}
function P(t, n) {
  return r("white-space", t, n);
}
function Q(t, n) {
  return r("text-overflow", t, n);
}
function tt(t, n) {
  return r("text-transform", t, n);
}
function nt(t, n) {
  return r("letter-spacing", t, n);
}
const e = [0, 1, 2];
function rt(t, n) {
  if (process.env.NODE_ENV === "development" && t !== void 0 && !e.includes(Number(t)))
    throw new Error(
      `Z index value ${t} is not supported - please use a value from ALLOWED_Z_INDEX_VALUES: ${e}`
    );
  return r("z-index", t, n);
}
function et(t, n) {
  return r("visibility", t, n);
}
function ot(t, n) {
  return r("opacity", t, n);
}
function it(t, n) {
  return r("resize", t, n);
}
function ut(t, n) {
  return r("-webkit-tap-highlight-color", t, n);
}
export {
  d as alignItems,
  a as alignSelf,
  S as aspectRatio,
  i as background,
  C as backgroundColor,
  W as border,
  H as borderBottomStyle,
  I as borderColor,
  T as borderRightStyle,
  N as borderStyle,
  D as bottom,
  O as boxShadow,
  u as boxSizing,
  L as color,
  E as cursor,
  f as display,
  V as fill,
  h as flex,
  g as flexDirection,
  p as flexWrap,
  F as fontSize,
  q as fontWeight,
  $ as gridArea,
  R as gridTemplateAreas,
  U as gridTemplateColumns,
  w as height,
  c as justifyContent,
  s as justifyItems,
  l as justifySelf,
  j as left,
  nt as letterSpacing,
  G as lineHeight,
  y as maxHeight,
  x as maxWidth,
  v as minHeight,
  b as minWidth,
  ot as opacity,
  Z as outline,
  M as overflow,
  K as overflowX,
  J as overflowY,
  k as pointerEvents,
  z as position,
  it as resize,
  _ as right,
  X as stroke,
  B as textAlign,
  Y as textDecoration,
  Q as textOverflow,
  tt as textTransform,
  A as top,
  et as visibility,
  ut as webkitTapHighlightColor,
  P as whiteSpace,
  m as width,
  rt as zIndex
};
